// extracted by mini-css-extract-plugin
module.exports = {"container":"e40b8__index-module__container","link":"_31e1f__index-module__link"};